import { Component } from '@angular/core';
import { ContentService } from '../../../services/content/content.service';
import { ChatterCommandList } from '../../../components/chatter/chatter.model';
import { Router } from '@angular/router';
import { FunctieResource } from '../../../services/resources/functie.resource';
import { switchMap, tap } from 'rxjs/operators';
import { CompareService } from '../../../services/compare/compare.service';
import { Functie } from '../../../model';
import { PrismicService } from "../../../services/prismic/prismic.service";
import {PrismicFlowConfig} from "../../../../types/app-types";

const content = require('./functie-toekomst-opbouw-page.content.json');

@Component({
  selector: 'app-profiel-opbouw-page',
  templateUrl: './functie-toekomst-opbouw-page.component.html',
  styleUrls: ['./functie-toekomst-opbouw-page.component.scss']
})
export class FunctieToekomstOpbouwPageComponent {
  public chatterDefinition: ChatterCommandList;
  public mode: string;

  public constructor(
    private contentService: ContentService,
    private router: Router,
    private functieResource: FunctieResource,
    private compareService: CompareService,
    private prismic: PrismicService
  ) {
    this.prismic.getDocumentByUid<PrismicFlowConfig>("flow_config", "toekomstproef-functie-flowconfig").then(doc => {
      this.chatterDefinition = JSON.parse(doc.data.chatflow_config[0].text) as ChatterCommandList;
    });

    this.contentService.loadContent(content);
  }

  public handleFlowResponse($event) {
    this.compareService.reset();

    const functieFirstTry = $event.responseMap.$functie.data && $event.responseMap.$functie.data[0];
    const functieRetry = $event.responseMap.$functieRetry.data && $event.responseMap.$functieRetry.data[0];

    const functie = functieFirstTry ? functieFirstTry : functieRetry;

    if (functie) {
      this.functieResource
        .getFunctie(functie.id)
        .pipe(
          tap((fn: Functie) => this.compareService.addItemToCompare(fn)),
          switchMap((fn: Functie) => this.functieResource.getFunctie(fn.toekomstfunctieId)),
          tap((tfn: Functie) => this.compareService.addItemToCompare(tfn)),
          tap(() => this.router.navigate(['/compare']))
        )
        .subscribe();
    } else {
      this.router.navigate(['/']);
    }
  }
}
